/* eslint-disable @typescript-eslint/no-explicit-any */
// forked from https://github.com/chakra-ui/chakra-ui/blob/main/packages/utils/src/dom.ts

function getTargetElement(target, defaultElement) {
  if (!target) {
    return defaultElement;
  }
  var targetElement;
  if (typeof target === 'function') {
    targetElement = target();
  } else if ('current' in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }
  return targetElement;
}
function getOwnerWindow(node) {
  var _getOwnerDocument$def;
  return node instanceof Element ? (_getOwnerDocument$def = getOwnerDocument(node).defaultView) !== null && _getOwnerDocument$def !== void 0 ? _getOwnerDocument$def : window : window;
}
function getOwnerDocument(node) {
  var _node$ownerDocument;
  return node instanceof Element ? (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : document : document;
}
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
var isBrowser = canUseDOM();

/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */
function normalizeEventKey(event) {
  var key = event.key,
    keyCode = event.keyCode;
  var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0;
  var eventKey = isArrowKey ? "Arrow".concat(key) : key;
  return eventKey;
}
var dataAttr = function dataAttr(condition) {
  return condition ? '' : undefined;
};
var ariaAttr = function ariaAttr(condition) {
  return condition ? true : undefined;
};
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(' ');
};
function getActiveElement(node) {
  var doc = getOwnerDocument(node);
  return doc === null || doc === void 0 ? void 0 : doc.activeElement;
}
function contains(parent, child) {
  return parent === child || parent.contains(child);
}
function findMatchingElement(element, targetElement) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return element === targetElement || (level > 0 ? findMatchingElement(element === null || element === void 0 ? void 0 : element.parentElement, targetElement, level - 1) : false);
}

export { ariaAttr, canUseDOM, contains, cx, dataAttr, findMatchingElement, getActiveElement, getOwnerDocument, getOwnerWindow, getTargetElement, isBrowser, normalizeEventKey };
//# sourceMappingURL=dom.esm.js.map
